import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {StocklogoController, StocklogoEventnames} from "./stocklogoController";
import {StockLogoPoolEntry} from "./stocklogoController";
import {StocklogoViewController} from "./stocklogoViewController";
import {afterBrowserRepaintDo} from "../../global/globalUtils";
import {HTMLPrinter} from "../../global/htmlprinter";
import {CONSTANTS} from "../meta_data";
import List from "list.js"

export class StockLogoSearch extends EventListener {
    private static liste;
    public static overlay;

    public constructor() {
        super();
        StockLogoSearch.overlay = $(".overlay-owayo-logopool_searchresults")
        StockLogoSearch.getSearchInputs().on("input", (event) => StockLogoSearch.handleSearchInput(event.currentTarget));
        StockLogoSearch.initCloseAndBackButtons();

        this.addEventListener("logoPoolChangedEvent", () => {
            StockLogoSearch.hideSearchOverlay();
            StockLogoSearch.emptySearchInputs();
        })
            .addEventListener(StocklogoEventnames.LOGOSLOADED, () => StockLogoSearch.writeAllEntriesToSearchList())
    }

    private static getSearchInputs = () => $(".search-logo-box .lsearch");
    private static emptySearchInputs = () => StockLogoSearch.getSearchInputs().val("");

    private static initCloseAndBackButtons() {
        StockLogoSearch.overlay.find(".btn-close").off().click(() => {
            StockLogoSearch.emptySearchInputs();
            StocklogoViewController.hideOverlays()
        });
        StockLogoSearch.overlay.find(".btn-back").off().click(() => {
            StockLogoSearch.emptySearchInputs();
            StockLogoSearch.hideSearchOverlay();
        });
    }

    public static hideSearchbar() {
        $(".search-logo-box").hide();
    }

    public static showSearchbar() {
        $(".search-logo-box").show();
    }

    private static showSuchoverlay = () => StockLogoSearch.overlay.addClass("active");
    public static hideSearchOverlay = () => StockLogoSearch.overlay.removeClass("active");

    private static showNoResultsHeader() {
        StockLogoSearch.overlay.find(".logo-upload-meta .no-results").addClass("active");
        StockLogoSearch.overlay.find(".logo-upload-meta .intro").hide();
    }

    private static hideNoResultsHeader() {
        StockLogoSearch.overlay.find(".logo-upload-meta .no-results").removeClass("active");
        StockLogoSearch.overlay.find(".logo-upload-meta .intro").show();
    }

    private static loadImages(list) {
        list.forEach(e => {
            const $e = $(e.elm).find("img[data-src]");
            if ($e.length === 0) {
                return;
            }
            $e.prop("src", $e.data("src")).removeData("src");
        })
    }

    private static handleSearchInput(element) {
        const searchVal = element.value;
        StockLogoSearch.getSearchInputs().val(searchVal);
        if (searchVal === "") {
            StockLogoSearch.hideSearchOverlay();
            StocklogoViewController.showOverlay("logopool");
            afterBrowserRepaintDo(() => $(".overlay-owayo-logopool .lsearch").focus());
            return;
        }
        StockLogoSearch.showSuchoverlay();
        setTimeout(() => StockLogoSearch.overlay.find(".lsearch").focus(), 1);
        const list = StockLogoSearch.liste.search(searchVal.trim());
        list.length === 0 ? StockLogoSearch.showNoResultsHeader() : StockLogoSearch.hideNoResultsHeader();
        if (searchVal.length > 1) {
            setTimeout(() => {
                StockLogoSearch.loadImages(list);
            }, CONSTANTS.INPUT_PROCESSING_DELAY);
        }
    }

    public static writeAllEntriesToSearchList() {
        const categories = StocklogoController.getLogos();
        const searchresultContainer = $(".overlay-owayo-logopool_searchresults .logo-upload-content ul").empty();
        categories.forEach(
            c => searchresultContainer.append(StockLogoSearch.getSearchListEntries(c.logos))
        );
        afterBrowserRepaintDo(() => {
            StockLogoSearch.liste = new List($(".overlay-owayo-logopool_searchresults")[0], {valueNames: [{data: ["keywords"]}]})
            StockLogoSearch.overlay.find(".logo-box").click(function (event) {
                const id = $(event.currentTarget).data("id");
                EventVerteiler.broadcast(StocklogoEventnames.LOGOCLICKED, id);
            })
        });
    }

    private static getSearchListEntries(categoryLogos: StockLogoPoolEntry[]) {
        let containers = "";
        for (const l in categoryLogos) {
            containers += StockLogoSearch.getSearchListEntry(categoryLogos[l]);

        }
        return containers;
    }


    private static getSearchListEntry(logo: StockLogoPoolEntry) {
        const p = HTMLPrinter;
        return p.liWithProps(
            p.cssClass("logo-box"),
            p.dataProp("id")(logo.stockLogoID),
            p.dataProp("keywords")(logo.keywords.join(","))
        )(
            p.divWitHProps(p.cssClass("box-wrapper"))(
                p.divWitHProps(p.cssClass("logo-img-wrapper"))(
                    p.img(
                        p.cssClass("logo-box-image-owayo"),
                        p.alt(logo.Name),
                        p.dataProp("src")("/" + logo.previewPicture),
                        p.src("img/ajax-loader_new.gif"),
                    ),
                    p.span("")
                )
            )
        );
    }

}
